import { AxiosResponse } from "axios";
import { put, call, throttle } from "redux-saga/effects";
import { dispatchLoyaltyRedeemAfterOrder } from "../cart/cartSaga";
import { Store } from "../../configureStore";
import { trackEvent, ANALYTICS_EVENTS, normalizeOrderType } from "../../../utils/analytics";
import {
  errorRazorPayTransferOrder,
  failureRazorPayTransferOrder,
  PaymentActions,
  succesRazorPayTransferOrder,
  firstDataPaymentSuccess,
  firstDataPaymentFailure,
  stripePaymentTokenRetrievealSuccess,
  stripePaymentFailure,
  stripePaymentSuccess,
  offlinePaymentSuccess,
  offlinePaymentFailure,
  cnpDataPaymentFailure,
  cnpDataPaymentSuccess,
  tokenizeCardDetailSuccess,
  tokenizeCardDetailFailure,
  saveCardDetailSuccess,
  saveCardDetailFailure,
  saveCardDetailAction,
  getCardDetailsSuccess,
  getCardDetailsFailure,
  deleteCardDetailsSuccess,
  deleteCardDetailsFailure,
  isRazorPayClicked,
} from "./PaymentActions";
import {
  razorPayTransferOrderAPI,
  catpurePaymentAPI,
  firstDataTransferOrderAPI,
  stripeInitatePaymentAPI,
  offlinePaymentAPI,
  initiatetCNPPayemnetAPI,
  tokenizeCardDetail,
  saveCardDetail,
  getCardDetails,
  deleteCardDetails,
} from "./PaymentAPI";
import {
  CNP_DATA_PAYMENT_REQUEST,
  DELETE_CARD_DETAILS_REQUEST,
  FIRST_DATA_PAYMENT_REQUEST,
  GET_CARD_DETAILS_REQUEST,
  OFFLINE_PAYMENT_REQUEST,
  RAZOR_PAY_TRANSFER_ORDER,
  SAVE_CARD_DETAILS_REQUEST,
  STRIPE_CAPTURE_PAYMENT,
  STRIPE_PAYMENT_REQUEST,
  TOKENIZE_CARD_DETAILS_REQUEST,
} from "./PaymentConstants";
import {
  CNPDataOrder,
  FirstDataOrder,
  RazorPayTransferOrder,
  RazorPayTransferredOrder,
  StripeCapturePaymentPayload,
  StripeInitiatePaymentPayload,
} from "./PaymentModels";
import { decryptJson } from "../../utils/react-ec-utils";
import { showErrorToast, showErrorToastDesktop } from "../../utils/toastUtils";
import { getCookie } from "../../../helper/cookieHelper";
import { USER_DETAILS, USER_ID } from "../../constants";
import { validateAndParseResponse } from "../../utils/hmac-utils";

const userDetailsFromCookie = getCookie(USER_DETAILS) || {};
const userIdFromCookie = getCookie(USER_ID) || "";

// Sagas run outside React, so order_type/grand_total for the payment_failed event
// are read directly off the store rather than from component-scoped selectors.
function trackCardPaymentFailed(request: CNPDataOrder) {
  const state: any = Store.getState();
  trackEvent(ANALYTICS_EVENTS.PAYMENT_FAILED, {
    order_type: normalizeOrderType(state?.cart?.currentOrderType),
    grand_total: request?.totalPaymentAmount,
    payment_method: 'card',
  });
}

function* razorPayTransferOrderSaga(action: any):any {
  try {
    const isMobile = window.innerWidth <= 768;

    const response: AxiosResponse = yield call(
      razorPayTransferOrderAPI,
      action.payload
    );
      const parsedResponse = yield call(validateAndParseResponse, response.data);

    if (!parsedResponse?.valid) {
      if (isMobile) {
        showErrorToast(parsedResponse?.message || 'Failed to update profile, Please try Again');
      } else {
        showErrorToastDesktop(
          parsedResponse?.message || 'Failed to update profile, Please try Again'
        );
      }
      return;
    }

    if (response.status === 200) {
      // const decryptdata = decryptJson(response?.data?.encryptedText);
        const decryptdata = response?.data?.data
      yield put(
        succesRazorPayTransferOrder(decryptdata as RazorPayTransferredOrder)
      );
      yield put(isRazorPayClicked(false));
    } else {
      if(isMobile){
        showErrorToast(response?.data?.message)
      }else{
        showErrorToastDesktop(response?.data?.message)
      }
      yield put(isRazorPayClicked(false));
      yield put(
        failureRazorPayTransferOrder({
          message: response?.data?.message,
        })
      );
    }
  } catch (err) {
    const isMobile = window.innerWidth <= 768;
    yield put(isRazorPayClicked(false));
    if(isMobile){
      showErrorToast("Something went wrong!")
    }else{
      showErrorToastDesktop("Something went wrong!")
    }
    yield put(errorRazorPayTransferOrder("Please Try Again"));
  }
}

function* firstDataPaymentSaga(action: any):any {
    const isMobile = window.innerWidth <= 768;
  try {
    const response: AxiosResponse = yield call(
      firstDataTransferOrderAPI,
      action.payload as FirstDataOrder
    );
     const parsedResponse = yield call(validateAndParseResponse, response.data);

    if (!parsedResponse?.valid) {
      if (isMobile) {
        showErrorToast(parsedResponse?.message || 'Failed to update profile, Please try Again');
      } else {
        showErrorToastDesktop(
          parsedResponse?.message || 'Failed to update profile, Please try Again'
        );
      }
      return;
    }

    // const decryptedData = decryptJson(response?.data?.encryptedText);
      const decryptedData = response?.data?.data
    if (response.status === 200 && decryptedData.paymentStatus === "18") {
      let reqBody = action.payload;
      reqBody.token = decryptedData.paymentTransactionTokenId;
      const paymentResponse: AxiosResponse = yield call(
        catpurePaymentAPI,
        action.payload as any
      );
           const parsedpaymentResponse = yield call(validateAndParseResponse, paymentResponse.data);

    if (!parsedpaymentResponse?.valid) {
      if (isMobile) {
        showErrorToast(parsedpaymentResponse?.message || 'Failed to update profile, Please try Again');
      } else {
        showErrorToastDesktop(
          parsedpaymentResponse?.message || 'Failed to update profile, Please try Again'
        );
      }
      return;
    }
      // const decryptdata = decryptJson(paymentResponse?.data?.encryptedText);
        const decryptdata = response?.data?.data
      if (
        paymentResponse.status === 200 &&
        decryptdata.paymentStatus === "19"
      ) {
        yield put(firstDataPaymentSuccess());
      } else {
        yield put(firstDataPaymentFailure());
      }
    } else {
      yield put(firstDataPaymentFailure());
    }
  } catch (err) {
    console.error(err);
  }
}

function* stripeInitiatePaymentSaga(action: any) {
  try {
    const paymentResponse: AxiosResponse = yield call(
      stripeInitatePaymentAPI,
      action.payload as StripeInitiatePaymentPayload
    );
    if (
      paymentResponse.status === 200 &&
      paymentResponse.data.paymentStatus === "18"
    ) {
      yield put(
        stripePaymentTokenRetrievealSuccess(
          paymentResponse.data.paymentTransactionId
        )
      );
    } else {
      yield put(stripePaymentFailure());
    }
  } catch (err) {
    console.error(err);
  }
}

function* offlinePaymentSaga(action: any):any {
    const isMobile = window.innerWidth <= 768;
  const useV2TransactionApi = Boolean(
    action.payload?.tableId || action.payload?.forceV2TransactionApi
  );
  try {
    let callBackFunc = null;
    if (
      action.payload?.sagaCallBack != null &&
      typeof action.payload?.sagaCallBack === "function"
    ) {
      callBackFunc = action.payload?.sagaCallBack;
      delete action.payload?.sagaCallBack;
    }
    const paymentResponse: AxiosResponse = yield call(
      offlinePaymentAPI,
      action.payload as any
    );
    let decryptedData = null;
    if (useV2TransactionApi) {
      decryptedData = paymentResponse?.data?.encryptedText
        ? decryptJson(paymentResponse.data.encryptedText)
        : paymentResponse?.data?.data;
    } else {
      const parsedResponse = yield call(validateAndParseResponse, paymentResponse?.data);
      if (!parsedResponse?.valid) {
        if (isMobile) {
          showErrorToast(parsedResponse?.message || 'Failed to update profile, Please try Again');
        } else {
          showErrorToastDesktop(
            parsedResponse?.message || 'Failed to update profile, Please try Again'
          );
        }
        yield put(offlinePaymentFailure(parsedResponse?.message || "Offline Payment Failed"));
        if (callBackFunc != null) {
          callBackFunc(false);
        }
        return;
      }
      decryptedData = paymentResponse?.data?.data;
    }

    if (paymentResponse.status === 200) {
      yield put(offlinePaymentSuccess(decryptedData));
      try {
        localStorage.removeItem('pendingLoyaltyRewards');
        window.dispatchEvent(new CustomEvent('loyalty:pending-rewards-change'));
      } catch {}
      yield* dispatchLoyaltyRedeemAfterOrder(
        { orderId: action.payload?.orderId },
        {}
      );
      if (callBackFunc != null) {
        callBackFunc(true);
      }
    } else {
      yield put(offlinePaymentFailure("Offline Payment Failed"));
      if (callBackFunc != null) {
        callBackFunc(false);
      }
    }
  } catch (err: any) {
    console.error(err);
    yield put(offlinePaymentFailure("Offline Payment Failed"));
  }
}

function* stripeCapturePaymentSaga(action: any) {
  try {
    const paymentResponse: AxiosResponse = yield call(
      catpurePaymentAPI,
      action.payload as StripeCapturePaymentPayload
    );
    if (
      paymentResponse.status === 200 &&
      paymentResponse.data.paymentStatus === "19"
    ) {
      yield put(stripePaymentSuccess());
    } else {
      yield put(stripePaymentFailure());
    }
  } catch (err) {
    console.error(err);
  }
}

function* cnpDataPaymentSaga(action: any):any {
  let initiatePaymentRequest = action.payload as CNPDataOrder;
  const useV2TransactionApi = Boolean(
    action.payload?.tableId || action.payload?.forceV2TransactionApi
  );
  const isMobile = window.innerWidth <= 768;
  try {
    const initiatePaymentResponse: AxiosResponse = yield call(
      initiatetCNPPayemnetAPI,
      initiatePaymentRequest
    );
    let decryptedData = null;

    if (useV2TransactionApi) {
      decryptedData = initiatePaymentResponse?.data?.encryptedText
        ? decryptJson(initiatePaymentResponse.data.encryptedText)
        : initiatePaymentResponse?.data?.data;
    } else {
      const parsedResponse = yield call(validateAndParseResponse, initiatePaymentResponse?.data);
      if (!parsedResponse?.valid) {
        const errorMessage =
          parsedResponse?.message ||
          initiatePaymentResponse?.data?.message ||
          "Failed to update profile, Please try Again";
        if (isMobile) {
          showErrorToast(errorMessage);
        } else {
          showErrorToastDesktop(errorMessage);
        }
        yield put(cnpDataPaymentFailure(errorMessage));
        trackCardPaymentFailed(initiatePaymentRequest);
        if (
          initiatePaymentRequest?.sagaCallBack != null &&
          typeof initiatePaymentRequest?.sagaCallBack === "function"
        ) {
          initiatePaymentRequest.sagaCallBack(false);
        }
        return;
      }
      decryptedData = initiatePaymentResponse?.data?.data;
    }

    if (initiatePaymentResponse.status === 200) {
      if (
        initiatePaymentResponse.status === 200 &&
        decryptedData.paymentStatus === "19"
      ) {
        yield put(cnpDataPaymentSuccess());
        try {
          localStorage.removeItem('pendingLoyaltyRewards');
          window.dispatchEvent(new CustomEvent('loyalty:pending-rewards-change'));
        } catch {}
        yield* dispatchLoyaltyRedeemAfterOrder(
          { orderId: initiatePaymentRequest?.orderId },
          { locationId: initiatePaymentRequest?.locationId }
        );
        if (
          initiatePaymentRequest?.sagaCallBack != null &&
          typeof initiatePaymentRequest?.sagaCallBack === "function"
        ) {
          initiatePaymentRequest.sagaCallBack(true);
        }
      } else {
        yield put(cnpDataPaymentFailure(decryptedData.message));
        trackCardPaymentFailed(initiatePaymentRequest);
        if (
          initiatePaymentRequest?.sagaCallBack != null &&
          typeof initiatePaymentRequest?.sagaCallBack === "function"
        ) {
          initiatePaymentRequest.sagaCallBack(false);
        }
      }
    } else {
      const errorMessage =
        initiatePaymentResponse?.data?.message ||
        decryptedData?.message ||
        "Unknown error occurred";
      yield put(cnpDataPaymentFailure(errorMessage));
      trackCardPaymentFailed(initiatePaymentRequest);
      if (
        initiatePaymentRequest?.sagaCallBack != null &&
        typeof initiatePaymentRequest?.sagaCallBack === "function"
      ) {
        initiatePaymentRequest.sagaCallBack(false);
      }
    }
  } catch (err) {
    console.error({ err });
    let errorMessage = (err as any)?.response?.data?.message || (err as Error).message || "Unknown error occurred";
    if ((err as any)?.response?.data?.encryptedText) {
      try {
        errorMessage = decryptJson((err as any).response.data.encryptedText)?.message || errorMessage;
      } catch {}
    }
    yield put(cnpDataPaymentFailure(errorMessage));
    trackCardPaymentFailed(initiatePaymentRequest);
    if (
      initiatePaymentRequest?.sagaCallBack != null &&
      typeof initiatePaymentRequest?.sagaCallBack === "function"
    ) {
      initiatePaymentRequest.sagaCallBack(false);
    }
  }
}

function* tokenizeCardDetailSaga(action: any) {
  let sagaCallBack = null;
  let saveCardSagaCallBack = null;
  if (action.payload?.sagaCallBack !== null) {
    sagaCallBack = action.payload?.sagaCallBack;
    delete action.payload.sagaCallBack;
  }
  if (action.payload?.saveCardSagaCallBack !== null) {
    saveCardSagaCallBack = action.payload?.saveCardSagaCallBack;
    delete action.payload.saveCardSagaCallBack;
  }
  try {
    const cardSaveResponse: AxiosResponse = yield call(
      tokenizeCardDetail,
      action.payload
    );

    if (cardSaveResponse.status === 200) {
      yield put(tokenizeCardDetailSuccess(cardSaveResponse?.data));
      yield put(
        saveCardDetailAction({
          locationId: action.payload?.locationId,
          customerId: action.payload?.customerId,
          cvv: action.payload?.cvv,
          cardType: cardSaveResponse?.data?.Brand,
          expiryMonth: cardSaveResponse?.data?.ExpirationMonth,
          expiryYear: cardSaveResponse?.data?.ExpirationYear,
          // cardToken: cardSaveResponse?.data?.Token,
          lastFourDigits: cardSaveResponse?.data?.Last4,
          account: action.payload?.account,
          zipcode: action.payload?.zipcode,
          streetNo: action.payload?.streetNo,
          sagaCallBack: saveCardSagaCallBack ?? undefined,
          emailId: userDetailsFromCookie?.email || "",
          mobileNo: userDetailsFromCookie?.mobilePhone || "",
        })
      );
    } else {
      sagaCallBack(false, action.payload);     
      yield put(tokenizeCardDetailFailure());
    }
  } catch (err) {
    sagaCallBack(false, action.payload);
     yield put(tokenizeCardDetailFailure());
    console.error(err);
  }
}

function* saveCardDetailSaga(action: any):any {
  const isMobile = window.innerWidth <= 768;

  const sagaCallBack = action.payload?.sagaCallBack ?? null;
  try {
    if (sagaCallBack != null && typeof sagaCallBack === "function") {
      delete action.payload.sagaCallBack;
    }
    const cardSaveResponse: AxiosResponse = yield call(
      saveCardDetail,
      action.payload
    );
      const  parsedResponse = yield call(
            validateAndParseResponse,
           cardSaveResponse?.data
          );
       if(!parsedResponse?.valid)
               {
                  if (isMobile) {
                   showErrorToast(parsedResponse?.message || "Failed to update profile, Please try Again");
                 } else {
                   showErrorToastDesktop(parsedResponse?.message || "Failed to update profile, Please try Again");
                 }
               return ;
        }
     

    if (cardSaveResponse.status === 200) {
      if (sagaCallBack) {
        sagaCallBack(true);
      }
      yield put(saveCardDetailSuccess(cardSaveResponse?.data?.data));
    } else {
      if (sagaCallBack) {
        sagaCallBack(false);
      }
      if(!sagaCallBack){
        if(isMobile){
          showErrorToast("Invalid Card Details")
        }else{
          showErrorToastDesktop("Invalid Card Details")
        }
      }
      yield put(saveCardDetailFailure());
    }
  } catch (err: any) {
    if(!sagaCallBack){
      if(isMobile){
        showErrorToast('Something went wrong !')
      }else{
        showErrorToastDesktop('Something went wrong !')
      }
    }
    sagaCallBack(false);
    console.error(err);
  }
}

function* getCardDetailsSaga(action: any) {
  try {
    const cardSaveResponse: AxiosResponse = yield call(
      getCardDetails,
      action.payload
    );
    // const decryptedData = decryptJson(cardSaveResponse?.data?.encryptedText);
    if (cardSaveResponse.status === 200) {
      yield put(getCardDetailsSuccess(cardSaveResponse?.data));
    } else {
      yield put(getCardDetailsFailure(cardSaveResponse?.data));
    }
  } catch (err) {
    console.error(err);
  }
}

function* deleteCardDetailsSaga(action: any) {
  try {
    const cardSaveResponse: AxiosResponse = yield call(
      deleteCardDetails,
      action.payload
    );
    // const decryptedData = decryptJson(cardSaveResponse?.data?.encryptedText);
    if (cardSaveResponse.status === 200) {
      yield put(deleteCardDetailsSuccess(cardSaveResponse?.data));
      const customerId  = action.payload.customerId;
      if (customerId) {
        yield put({
          type: GET_CARD_DETAILS_REQUEST,
          payload: customerId ,
        });
      }

    } else {
      yield put(deleteCardDetailsFailure(cardSaveResponse?.data));
    }
  } catch (err) {
    console.error(err);
  }
}
export default function* paymentSaga() {
  yield throttle(3000, RAZOR_PAY_TRANSFER_ORDER, razorPayTransferOrderSaga);
  yield throttle(3000, TOKENIZE_CARD_DETAILS_REQUEST, tokenizeCardDetailSaga);
  yield throttle(3000, SAVE_CARD_DETAILS_REQUEST, saveCardDetailSaga);
  yield throttle(3000, FIRST_DATA_PAYMENT_REQUEST, firstDataPaymentSaga);
  yield throttle(3000, STRIPE_PAYMENT_REQUEST, stripeInitiatePaymentSaga);
  yield throttle(3000, STRIPE_CAPTURE_PAYMENT, stripeCapturePaymentSaga);
  yield throttle(3000, OFFLINE_PAYMENT_REQUEST, offlinePaymentSaga);
  yield throttle(3000, CNP_DATA_PAYMENT_REQUEST, cnpDataPaymentSaga);
  yield throttle(100, GET_CARD_DETAILS_REQUEST, getCardDetailsSaga);
  yield throttle(100, DELETE_CARD_DETAILS_REQUEST, deleteCardDetailsSaga);
}
